import React, { Fragment, useEffect, useState } from "react";
import Container from "../../../../../../../widgets/Container";
import SelectionBox from "../../../../../../../widgets/SelectionBox";
import { Grid } from "@mui/material";
import { SearchBtn } from "../../../../../../../widgets/AppBtn";
import InputTextBox from "../../../../../../../widgets/InputTextBox";
import {
  fetchDataFromApi,
  postDataToTheServer,
} from "../../../../../../../widgets/api";
import AppURL from "../../../../../../../widgets/AppURL";
import {
  AcademicsYearOptions,
  ProgramOptions,
  SectionOptions,
  SubjectOptions,
  YearSemesterOptions,
} from "../../../../../../../widgets/Options";
import { useFormik } from "formik";
import InputNumberBox from "../../../../../../../widgets/InputNumberBox";

const StdAttendaceSearchView = ({ setOnAttendanceData }) => {
    const teacher_id = sessionStorage.getItem("teacherAuth");
  const [isLoading, setOnLoading] = useState(false);
  const [onStudentOptionList, setOnStudentOptionList] = useState([]);
  const [yearSemMajSub, setOnYearSemMajorSub] = useState([]);
  const fetchStudentFilterOptionListView = async () => {
    setOnLoading(true);
    try {
      await fetchDataFromApi(
        AppURL.ExamURL + "exam-student-filter-options-list-view/"
      ).then((res) => {
        setOnStudentOptionList(res);
        setOnLoading(false);
      });
    } catch (error) {
      console.log(error);
      setOnLoading(false);
    }
  };
  useEffect(() => {
    fetchStudentFilterOptionListView();
  }, []);
  const ProgramOption = ProgramOptions(onStudentOptionList?.program);
  const SectionOption = SectionOptions(onStudentOptionList?.section);
  const AcademicsYearOption = AcademicsYearOptions(
    onStudentOptionList?.acdmc_year
  );
  const [isSubjectList, setOnSubjList] = useState([]);

  const initialValues = {
    program: "",
    section: "",
    medium: "",
    acdmc_year: "",
    year_semester: "",
    date: "",
    teacher_id: "",
    subjects: "",
  };

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    isSubmitting,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: async (values, action) => {
      const formData = new FormData();
      formData.append("program", values.program);
      formData.append("year_semester", values.year_semester);
      formData.append("acdmc_year", values.acdmc_year);
      formData.append("section", values.section);
      formData.append("subjects", values.subjects);
      formData.append("month", values.month);
      formData.append("teacher_id", teacher_id);
      try {
        await postDataToTheServer(
          AppURL.ExamURL + "exam-student-attendance-one-month-report-view/",
          formData
        ).then((res) => {
          setOnAttendanceData(res);
        });
      } catch (error) {
        console.log(error);
      }
    },
  });

  const fetchYearSemesterMajorSubList = async () => {
    if (values?.program) {
      try {
        await fetchDataFromApi(
          AppURL.AcademicsURL +
            "academic-student-year-semester-filter-list/?program_id=" +
            values?.program
        ).then((res) => {
          setOnYearSemMajorSub(res);
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

 const fetchSubjectList = async () => {
    if ((values?.program, values?.year_semester)) {
      await fetchDataFromApi(
        AppURL.ExamURL +
          "exam-student-class-routine-wise-subject-list-view/?program=" +
          values?.program +
          "&&year_semester=" +
          values?.year_semester +
          "&&acdmc_year=" +
          values?.acdmc_year+
          "&&section=" +
          values?.section+
          "&&teacher_id=" +
          teacher_id
      ).then((res) => {
        setOnSubjList(res);
      });
    }
  };
  useEffect(() => {
    fetchSubjectList();
  }, [values?.program, values?.acdmc_year, values?.year_semester, values.section]);

  useEffect(() => {
    fetchYearSemesterMajorSubList();
  }, [values?.program, values?.year_semester]);

  const subjectOptions = SubjectOptions(isSubjectList?.results);
  const YearSemesterOption = YearSemesterOptions(yearSemMajSub?.year_semester);
  return (
    <Fragment>
      <Container>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
              <SelectionBox
                label={"Program"}
                placeholder=""
                isLoading={isLoading}
                value={values.program}
                options={ProgramOption}
                name="program"
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data.value)
                }
                handleBlur={handleBlur}
                touched={touched.program}
                errors={errors.program}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
              <SelectionBox
                label={"Year Semester"}
                isLoading={isLoading}
                value={values.year_semester}
                options={YearSemesterOption}
                name="year_semester"
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data.value)
                }
                handleBlur={handleBlur}
                touched={touched.year_semester}
                errors={errors.year_semester}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
              <SelectionBox
                label={"Acdmc Year"}
                isLoading={isLoading}
                value={values.acdmc_year}
                options={AcademicsYearOption}
                name="acdmc_year"
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data.value)
                }
                handleBlur={handleBlur}
                touched={touched.acdmc_year}
                errors={errors.acdmc_year}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
              <SelectionBox
                label={"Section"}
                isLoading={isLoading}
                value={values.section}
                options={SectionOption}
                name="section"
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data.value)
                }
                handleBlur={handleBlur}
                touched={touched.section}
                errors={errors.section}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
              <SelectionBox
                label="Subjects"
                name={"subjects"}
                value={values.subjects}
                options={subjectOptions}
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data.value)
                }
                errors={errors.subjects}
                handleBlur={handleBlur}
                touched={touched.subjects}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
               <InputNumberBox
                name="month"
                value={values.month}
                disabled={false}
                handleChange={handleChange}
                mask="9999/99"
                required={true}
                label={"Year/Month"}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex items-end mt-1 justify-end h-full">
                <SearchBtn type="submit" isSubmitting={isSubmitting} />
              </div>
            </Grid>
          </Grid>
        </form>
      </Container>
    </Fragment>
  );
};

export default StdAttendaceSearchView;
